import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import FloatPostButton from '../../common/components/FloatPostButton';
import SignInModal from 'flarum/forum/dianLiang/SignInModal';
import Button from 'flarum/common/components/Button';
import TagsPage from 'flarum/tags/components/TagsPage';
import LinkButton from 'flarum/common/components/LinkButton';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import LogInModal from 'flarum/forum/components/LogInModal';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
//主页
export default class HomePage extends Page {
  lastDiscussion;
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    if (app.previous.matches(DiscussionPage)) {
      this.lastDiscussion = app.previous.get('discussion');
    }
    if (app.previous.matches(HomePage)) {
      app.discussions.clear();
    }
    app.setTitle(app.translator.trans('dl-index.forum.indexPage'));
    let params = app.search.changeSort2('front');
    app.history.push('index', '首页');
    app.discussions.refreshParams(params, (m.route.param('page') && Number(m.route.param('page'))) || 1);

    app.tagList
      .load([
        'children',
        'lastPostedDiscussion',
        'parent',
        'wikiLabel',
        'wikiLabel.wikiLabelOptions',
        'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon',
        'wikiHeroDetailDiscussion',
        'heroTagLatestdata' ,'heroTagLatestdata.heroTagHeroIntro' ,'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel'
      ])
      .then(() => {
        this.loading = false;
        m.redraw();
      });
    if (!app.cache.heroHeight) {
      app.cache.heroHeight = {};
    }
    if (!app.cache.scrollTop) {
      app.cache.scrollTop = {};
    }
  }
  oncreate(vnode) {
    super.oncreate(vnode);

    // Work out the difference between the height of this hero and that of the
    // previous hero. Maintain the same scroll position relative to the bottom
    // of the hero so that the sidebar doesn't jump around.
    const oldHeroHeight = app.cache.heroHeight['HomePage'];
    const heroHeight = (app.cache.heroHeight['HomePage'] = this.$('.Hero').outerHeight() || 0);
    const scrollTop = app.cache.scrollTop['HomePage'];

    $('#app').css('min-height', ($(window).height() || 0) + scrollTop);

    // Let browser handle scrolling on page reload.
    if (app.previous.type == null) return;

    // Only retain scroll position if we're coming from a discussion page.
    // Otherwise, we've just changed the filter, so we should go to the top of the page.
    if (this.lastDiscussion || scrollTop) {
      $(window).scrollTop(scrollTop - oldHeroHeight + heroHeight);
    } else {
      $(window).scrollTop(0);
    }
    if (this.lastDiscussion) {
      const $discussion = this.$(`li[data-id="${this.lastDiscussion.id()}"] .DiscussionListItem`);

      if ($discussion.length) {
        const indexTop = $('#app-navigation').outerHeight() || 0;
        const indexBottom = $(window).height() || 0;
        const discussionOffset = $discussion.offset();
        const discussionTop = (discussionOffset && discussionOffset.top) || 0;
        const discussionBottom = discussionTop + ($discussion.outerHeight() || 0);

        if (discussionTop < scrollTop + indexTop || discussionBottom > scrollTop + indexBottom) {
          $(window).scrollTop(discussionTop - indexTop);
        }
      }
    }
  }

  onbeforeremove(vnode) {
    super.onbeforeremove(vnode);

    // Save the scroll position so we can restore it when we return to the
    // discussion list.
    app.cache.scrollTop['HomePage'] = $(window).scrollTop();
  }
  onremove(vnode) {
    super.onremove(vnode);

    $('#app').css('min-height', '');
  }
  view() {
    // let list = app.store
    //     .all('discussions')
    //     .filter((discussion) => discussion.frontpage() == 1).sort((a, b) => b.id() - a.id());
    let feedbackUrl = window.location.origin;
    let feedbackStatus = app.session.user &&  app.forum.attribute('feedbackStatus');
    return (
      <div>
        <div className="Pages-page">
          <div className="dl-header-tabs">{PagePage.prototype.headerTabs(this)}</div>
          <div className="dl-content">
            {PagePagePC.prototype.headerSlideShowView()}
            <div className="dl-content-lin">
              {PagePage.prototype.centerTabs()}
              {/* <div className="mall-btn">
              <LinkButton className="" href={app.route('pay.mall', { type: 'postMalled' })}>
                {app.translator.trans('dl-pay.forum.user.mall_enter')}
              </LinkButton>
            </div> */}
              <div className="dl-discussion-container dl-discussion-container-lin">
                <DiscussionList state={app.discussions} />
              </div>
            </div>
          </div>
          {/* :<TagsPage></TagsPage>
        } */}
        </div>
        {feedbackStatus && (
          <Button
            className="customer-service"
            aria-label="feedback"
            onclick={(event) => {
              let $url = app.forum.attribute('baseUrl');
              if (!app.session.user) {
                event.preventDefault();
                app.modal.show(LogInModal);
                return;
              }
              let entranceId = app.data.pkgLogo.entranceId;
              // 打开反馈页面
              AIHelpSupport.show(entranceId ? entranceId : 'E001');
              // if (app.session.user.isAdmin()) {
              //   window.open(`${feedbackUrl}/feedback/?userId=${app.session.user.uniqueID()}&isAdmin=${app.session.user.isAdmin()}&pkgId=${app.data.pkgLogo.id}&lang=${app.data.locale}#/AdminFeedbackList`);
              // } else {
              //   window.open(`${feedbackUrl}/feedback/?userId=${app.session.user.uniqueID()}&isAdmin=${app.session.user.isAdmin()}&pkgId=${app.data.pkgLogo.id}&lang=${app.data.locale}&avatar=${app.session.user.avatarUrl()}#/userFeedback`);
              // }
            }}
          >
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btm-kef.png`}></img>
          </Button>
        )}
        {!app.session.user?.isSuspended() && <FloatPostButton />}
      </div>
    );
  }
}
